/**
 * "Continue where you left off": the items this browser looked at recently,
 * shown on the landing page when the buyer-care switch is on. Works for
 * visitors without an account (it reads this browser's memory only).
 */
import { Link } from "react-router-dom";
import { useBuyerExperience, recentlyViewed } from "../../buyerCare";
import { formatCurrency } from "../../common/functions";

export const ContinueWhereLeftOff = () => {
  const experience = useBuyerExperience();
  if (!experience.continueWhereLeftOff) return null;
  const items = recentlyViewed().slice(0, 6);
  if (!items.length) return null;
  return (
    <div className="mx-auto mt-10 max-w-4xl px-6 text-left">
      <div className="text-sm font-semibold text-gray-700">
        Continue where you left off
      </div>
      <ul className="mt-2 grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((item) => (
          <li key={item.id}>
            <Link
              to={`/product?id=${encodeURIComponent(item.id)}`}
              className="block rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-800 shadow-sm hover:border-gray-400"
            >
              <div className="line-clamp-2">{item.summary || item.id}</div>
              {item.price && (
                <div className="mt-1 text-xs text-gray-500">
                  {formatCurrency(item.price.value, item.price.currency)}
                  {item.price.unit ? ` / ${item.price.unit}` : ""}
                </div>
              )}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
